import { render } from "./FilterOption.vue?vue&type=template&id=1af1fa71&scoped=true"
import script from "./FilterOption.vue?vue&type=script&lang=js"
export * from "./FilterOption.vue?vue&type=script&lang=js"

import "./style.scss?vue&type=style&index=0&id=1af1fa71&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1af1fa71"]])

export default __exports__